//@flow

import React, { type Node } from 'react';
import { useDispatch } from 'react-redux';
import { Position, Text, Button } from '@locus-taxy/neo-ui';
import useChatGlobalState from 'common/modules/chat/hooks/useChatGlobalState';
import testIds from 'common/modules/chat/tests/chat.json';
import { ChatActions } from 'common/modules/chat/redux/actions/chat';

const ChatButton = (): Node => {
    const dispatch = useDispatch();
    const {
        isConnected,
        isChatWindowOpen,
        unreadChannelCount
    } = useChatGlobalState();

    const isAnyChannelUnread = unreadChannelCount > 0;

    const toggleChatWindow = () => {
        if (isChatWindowOpen) {
            dispatch(ChatActions.hideChatWindow());
        } else {
            dispatch(ChatActions.showChatWindow());
        }
    };

    return (
        <Position position="relative" ml={3} sx={{ flexShrink: 0 }}>
            <Button
                data-test-id={testIds.chatButton}
                appearance="icon"
                palette={isChatWindowOpen ? 'primary' : 'light'}
                icon="motiontrack_chat"
                onClick={toggleChatWindow}
                size="large"
                isLoading={!isConnected}
                disabled={!isConnected}
                border="none"
                sx={{
                    borderRadius: '4px',
                    backgroundColor: isChatWindowOpen ? 'blue.600' : 'initial',
                    color: isChatWindowOpen ? 'grey.200' : 'grey.400',
                    '&:focus, &:hover': {
                        color: 'grey.200',
                        backgroundColor: 'blue.600'
                    }
                }}
            >
                {isAnyChannelUnread ? (
                    <Position
                        position="absolute"
                        top="2px"
                        right="2px"
                        backgroundColor="red.500"
                        borderRadius="50%"
                        height="14px"
                        width="14px"
                    >
                        <Text color="white" fontSize="10px" lineHeight="12px">
                            {unreadChannelCount}
                        </Text>
                    </Position>
                ) : null}
            </Button>
        </Position>
    );
};

export default ChatButton;
